export default {
  data () {
    return {
      nowTime: '',
      nodesData: [], //渲染地图的数据
      totalNodes: 0, //总节点数
      nodesList:[],  //渲染节点列表数据
      isLoading: false
    }
  },
  mounted: function () {
    let date = new Date();
    let Year = date.getFullYear();
    let Month = date.getMonth()+1;
    let Day = date.getDate();
    this.nowTime = '截至' + Year + '年' + Month + '月' + Day + '日 （北京时间' + Month + '月' + Day + '日)';
    this.getNodesInfo();
  },
  methods: {
    netScanRespHandleBase: function(data) {
      this.isLoading = false;
      if(!data.result.countries){
        return
      }
      let len = data.result.countries.length
      for (let i = 0; i < len; i++){
        let item = data.result.countries[i];
        if(item.country !== 'XX'){
          this.totalNodes = this.totalNodes + item.value;
        }
      }
      data.result.countries.forEach(item => {
        if (item.country !== 'XX'){
          let percent = (item.value * 100 / this.totalNodes).toFixed(2) + '%';
          let place = '';
          switch (item.country) {
            case "中国":
              place = "中国大陆";
              break;
            case "香港":
            case "台湾":
            case "澳门":
              place = "中国" + item.country;
              break;
            default:
              place = item.country;
              break;
          }
          this.nodesList.push({
            name: place,
            value: item.value,
            percent: percent,
          })
          this.nodesData.push({
            name: place,
            value: item.value,
          })
        }
      });
      let compare = function (property){
        return function(obj1,obj2){
          let value1 = obj1[property];
          let value2 = obj2[property];
          return value2 - value1;     // 降序
        }
      };
      this.nodesList = this.nodesList.sort(compare('value'));

    }
  }
}